(() => {
  let locked = false;
  let returnFocus;
  let quantityTimer;
  const drawer = () => document.getElementById('zea-cart-drawer');
  const base = () => window.Shopify?.routes?.root || '/';
  const data = () => JSON.parse(drawer().querySelector('[data-zea-editor-data]').textContent);
  const readCart = async () => {
    const response = await fetch(base() + 'cart.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
    if (!response.ok) throw new Error('cart');
    return response.json();
  };
  const post = async (path, body) => {
    const response = await fetch(base() + path, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'cart');
    return result;
  };
  const refresh = async (open = true) => {
    const old = drawer();
    const url = new URL(old.dataset.sectionUrl, location.origin);
    url.searchParams.set('section_id', old.dataset.sectionId);
    const response = await fetch(url, {cache: 'no-store'});
    if (!response.ok) throw new Error('section');
    const next = new DOMParser().parseFromString(await response.text(), 'text/html').getElementById(old.id);
    if (!next) throw new Error('section');
    next.setAttribute('aria-busy',String(locked));
    const wasOpen = old.open;
    old.replaceWith(next);
    if (open || wasOpen) next.showModal();
    const header = await fetch(base() + '?section_id=zea-header');
    if (header.ok) {
      const link = new DOMParser().parseFromString(await header.text(), 'text/html').querySelector('.cart-link');
      if (link) document.querySelector('.site-header .cart-link')?.replaceWith(link);
    }
    const page = document.querySelector('[data-cart-section]');
    if (page) {
      const pageUrl = new URL(location.pathname,location.origin);
      pageUrl.searchParams.set('section_id',page.dataset.cartSection);
      const pageResponse = await fetch(pageUrl,{cache:'no-store'});
      if (pageResponse.ok) {
        const nextPage = new DOMParser().parseFromString(await pageResponse.text(),'text/html').querySelector('[data-cart-section]');
        if(nextPage) page.replaceWith(nextPage);
      }
    }
    return next;
  };
  const status = message => { const node = drawer()?.querySelector('[data-zea-cart-status]'); if (node) node.textContent = message; };
  const lock = value => {
    locked = value;
    const root = drawer();
    if (!root) return;
    root.setAttribute('aria-busy', String(value));
    root.querySelectorAll('button,input').forEach(control => {
      if (value) { control.dataset.wasDisabled = String(control.disabled); control.disabled = true; }
      else if ('wasDisabled' in control.dataset) { control.disabled = control.dataset.wasDisabled === 'true'; delete control.dataset.wasDisabled; }
    });
    const checkout = root.querySelector('.zea-cart-drawer__checkout');
    if (checkout) { checkout.setAttribute('aria-disabled', String(value)); checkout.tabIndex = value ? -1 : 0; }
  };
  const closeEditor = () => {
    drawer()?.querySelector('[data-zea-editor]')?.remove();
    drawer()?.classList.remove('has-editor');
    drawer()?.querySelector('[data-zea-second]')?.setAttribute('aria-expanded','false');
    if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
  };
  const selection = form => {
    const d = data();
    const model = form.elements.model.value;
    const box = form.elements.box.value;
    for (const input of form.querySelectorAll('[name="box"]')) input.disabled = !d.variants.some(v => v.model === model && v.box === input.value && v.available);
    const selected = d.variants.find(v => v.model === model && v.box === box);
    const valid = Boolean(selected?.available);
    form.querySelector('[data-editor-confirm]').disabled = !valid;
    form.querySelector('[data-editor-summary]').textContent = selected ? model + ' · ' + d.boxLabel + ' ' + box + ' · ' + selected.price : '';
    const photo = form.querySelector('[data-editor-photo]');
    const boxData = d.boxes.find(b => b.name === box);
    if (boxData) { photo.src = boxData.image; photo.alt = d.boxLabel + ' ' + box; }
    return valid ? selected : null;
  };
  const openEditor = (trigger, mode = 'add') => {
    if (locked) return;
    closeEditor();
    returnFocus = trigger;
    const root = drawer();
    const d = data();
    const row = trigger.closest('[data-zea-cart-item]');
    const form = root.querySelector('[data-zea-editor-template]').content.firstElementChild.cloneNode(true);
    form.dataset.mode = mode;
    form.dataset.key = row?.dataset.zeaCartItem || '';
    form.dataset.quantity = mode === 'all' ? row.dataset.quantity : '1';
    const initial = mode === 'add' ? d.variants.find(v => v.available && v.model !== root.querySelector('[data-zea-cart-item]')?.dataset.model) || d.variants.find(v => v.available) : d.variants.find(v => String(v.id) === row.dataset.variantId);
    if (!initial) return;
    for (const input of form.querySelectorAll('[name="model"]')) input.checked = input.value === initial.model;
    for (const input of form.querySelectorAll('[name="box"]')) input.checked = input.value === initial.box;
    form.querySelector('[data-editor-confirm]').textContent = mode === 'add' ? d.addLabel : d.saveLabel;
    form.querySelector('[data-editor-note]').textContent = mode === 'one' ? d.splitNote : mode === 'all' ? Number(row.dataset.quantity) > 1 ? d.manyNote.replace('__COUNT__',row.dataset.quantity) : d.oneNote : '';
    if (mode === 'add') {
      root.classList.add('has-editor');
      root.querySelector('[data-zea-editor-slot]').append(form);
      trigger.setAttribute('aria-expanded','true');
    } else row.after(form);
    selection(form);
    form.querySelector('h3').focus({preventScroll:true});
    form.scrollIntoView({block:'nearest',behavior:'instant'});
  };
  const updateQuantity = async (control, quantity) => {
    if (locked) return;
    clearTimeout(quantityTimer);
    const row = control.closest('[data-zea-cart-item]');
    lock(true);
    try {
      await post('cart/change.js',{id:row.dataset.zeaCartItem,quantity});
      const next = await refresh();
      next.querySelector('[data-zea-cart-close]').focus({preventScroll:true});
    } catch (error) { await refresh().catch(()=>{}); status(error.message); }
    finally { lock(false); }
  };
  const save = async form => {
    if (locked) return;
    const variant = selection(form);
    if (!variant) return;
    const d = data();
    const mode = form.dataset.mode;
    const key = form.dataset.key;
    const errorNode = form.querySelector('[data-editor-error]');
    errorNode.hidden = true;
    lock(true);
    let operation;
    let original;
    let remaining;
    let committed = false;
    let label = form.querySelector('[data-editor-confirm]').textContent;
    form.querySelector('[data-editor-confirm]').textContent = form.dataset.saving;
    try {
      const before = await readCart();
      original = mode === 'add' ? null : before.items.find(item => item.key === key);
      if (mode !== 'add' && !original) throw new Error(form.dataset.networkError);
      const quantity = mode === 'all' ? original.quantity : 1;
      if (original && String(original.variant_id) === String(variant.id)) { closeEditor(); return; }
      operation = crypto.randomUUID();
      const properties = {...(original?.properties || {}), Modelo:variant.model,'Caja floral':variant.box,Incluye:d.inclusions,_zea_edit:operation};
      try { await post('cart/add.js',{items:[{id:variant.id,quantity,properties}]}); }
      catch (error) {
        const check = await readCart();
        const added = check.items.find(item => item.properties?._zea_edit === operation);
        if (!added || added.quantity !== quantity) throw error;
      }
      const afterAdd = await readCart();
      const added = afterAdd.items.find(item => item.properties?._zea_edit === operation);
      if (!added || added.quantity !== quantity) throw new Error(form.dataset.stockError);
      if (original) {
        const currentOriginal = afterAdd.items.find(item => item.key === key);
        if (!currentOriginal || currentOriginal.quantity !== original.quantity) throw new Error(form.dataset.networkError);
        remaining = original.quantity - quantity;
        try { await post('cart/change.js',{id:key,quantity:remaining}); }
        catch (error) {
          const check = await readCart();
          const old = check.items.find(item => item.key === key);
          if ((old?.quantity || 0) !== remaining) throw error;
        }
      }
      committed = true;
      const next = await refresh();
      status(d.updated);
      next.querySelector('[data-zea-cart-close]').focus({preventScroll:true});
    } catch (error) {
      let message = form.dataset.stockError;
      if (operation && !committed) {
        try {
          const current = await readCart();
          const old = original && current.items.find(item => item.key === key);
          const added = current.items.find(item => item.properties?._zea_edit === operation);
          if (original && (old?.quantity || 0) === remaining) committed = true;
          else if (added) await post('cart/change.js',{id:added.key,quantity:0});
        } catch { message = form.dataset.recoveryError; }
      }
      if (committed) { await refresh().catch(()=>{}); status(d.updated); }
      else {
        errorNode.textContent = message;
        errorNode.hidden = false;
        status(message);
      }
    } finally {
      lock(false);
      if (form.isConnected) { form.querySelector('[data-editor-confirm]').textContent = label; selection(form); }
    }
  };
  window.zeaOpenCartDrawer = async () => {
    if (locked) return;
    returnFocus = document.activeElement;
    try { await refresh(true); } catch { if (!drawer().open) drawer().showModal(); }
    document.querySelector('[data-zea-cart-open]')?.setAttribute('aria-expanded','true');
  };
  document.addEventListener('click',async event=>{
    const pageEdit = event.target.closest('[data-zea-page-edit]');
    if (pageEdit) {
      event.preventDefault();
      await window.zeaOpenCartDrawer();
      const row = [...drawer().querySelectorAll('[data-zea-cart-item]')].find(item=>item.dataset.zeaCartItem===pageEdit.dataset.zeaPageEdit);
      if(row) openEditor(row.querySelector('[data-zea-edit="'+pageEdit.dataset.editMode+'"]'),pageEdit.dataset.editMode);
      return;
    }
    if (event.target.closest('.zea-cart-drawer__checkout[aria-disabled="true"]')) {event.preventDefault();return;}
    const open = event.target.closest('[data-zea-cart-open]');
    if (open) {event.preventDefault();window.zeaOpenCartDrawer();return;}
    if (event.target.closest('[data-zea-cart-close]')) {if(!locked)drawer().close();return;}
    const second = event.target.closest('[data-zea-second]');
    const edit = event.target.closest('[data-zea-edit]');
    if (second || edit) {openEditor(second || edit,edit?.dataset.zeaEdit || 'add');return;}
    if (event.target.closest('[data-editor-cancel]')) {if(!locked)closeEditor();return;}
    const remove = event.target.closest('[data-zea-cart-remove]');
    const step = event.target.closest('[data-zea-cart-step]');
    if (remove || step) {
      const row = event.target.closest('[data-zea-cart-item]');
      updateQuantity(remove || step,remove ? 0 : Math.max(0,Number(row.dataset.quantity)+Number(step.dataset.zeaCartStep)));
    }
  });
  document.addEventListener('change',event=>{
    const form = event.target.closest('[data-zea-editor]');
    if (form) selection(form);
    if (event.target.matches('[data-zea-cart-quantity]')) updateQuantity(event.target,Math.max(0,Math.floor(Number(event.target.value)||0)));
  });
  document.addEventListener('input',event=>{
    if (!event.target.matches('[data-zea-cart-quantity]')) return;
    const input = event.target;
    clearTimeout(quantityTimer);
    quantityTimer = setTimeout(()=>{
      if (input.isConnected && input.value !== '' && input.validity.valid) updateQuantity(input,Math.max(0,Math.floor(Number(input.value)||0)));
    },650);
  });
  document.addEventListener('submit',event=>{
    const form = event.target.closest('[data-zea-editor]');
    if(form){event.preventDefault();save(form);}
  });
  document.addEventListener('cancel',event=>{if(event.target.id==='zea-cart-drawer'&&locked)event.preventDefault();},true);
  document.addEventListener('close',event=>{
    if(event.target.id!=='zea-cart-drawer')return;
    document.querySelector('[data-zea-cart-open]')?.setAttribute('aria-expanded','false');
    (returnFocus?.isConnected ? returnFocus : document.querySelector('[data-zea-cart-open]'))?.focus({preventScroll:true});
  },true);
})();
